/* DRÖHN — WINTER APEX */
(() => {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = (window.TL && TL.moneyFormat) || '${{amount}}';
    const n = (cents / 100);
    const withDelims = (num, dec, thou, sep) => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }

  /* ---------- toast ---------- */
  let toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(() => toastEl.classList.remove('is-on'), 2400);
  }

  /* =========================================================
     HERO — pointer-driven parallax, streak, card tilt
     ========================================================= */
  function initHero(hero) {
    const st = { tx: 0, ty: 0, x: 0, y: 0, px: 50, py: 50, lastMove: 0, visible: true, raf: 0 };
    const activeCard = () => $('.hcard.is-active', hero);

    const onMove = (cx, cy) => {
      const r = hero.getBoundingClientRect();
      if (cy < r.top || cy > r.bottom) return;
      st.tx = clamp(((cx - r.left) / r.width) * 2 - 1, -1, 1);
      st.ty = clamp(((cy - r.top) / r.height) * 2 - 1, -1, 1);
      st.px = ((cx - r.left) / r.width) * 100;
      st.py = ((cy - r.top) / r.height) * 100;
      st.lastMove = performance.now();
      hero.dispatchEvent(new CustomEvent('hero:move', { detail: { cx, cy } }));
    };
    window.addEventListener('pointermove', e => onMove(e.clientX, e.clientY), { passive: true });
    hero.addEventListener('touchmove', e => { const t = e.touches[0]; if (t) onMove(t.clientX, t.clientY); }, { passive: true });

    // gentle idle drift so the scene breathes on touch devices
    const io = new IntersectionObserver(([en]) => { st.visible = en.isIntersecting; if (st.visible) loop(); }, { threshold: 0 });
    io.observe(hero);

    function loop() {
      cancelAnimationFrame(st.raf);
      if (!st.visible) return;
      const now = performance.now();
      const idle = now - st.lastMove > 2500;
      if (idle && !finePointer) { st.tx = Math.sin(now / 2600) * .35; st.ty = Math.cos(now / 3100) * .2; }
      st.x = lerp(st.x, st.tx, .07);
      st.y = lerp(st.y, st.ty, .07);
      hero.style.setProperty('--mx', st.x.toFixed(4));
      hero.style.setProperty('--my', st.y.toFixed(4));
      hero.style.setProperty('--px', st.px.toFixed(2) + '%');
      hero.style.setProperty('--py', st.py.toFixed(2) + '%');
      hero.style.setProperty('--streak-o', now - st.lastMove < 600 ? '1' : '0');
      const card = activeCard();
      if (card && !reduced) {
        card.style.setProperty('--ry', (st.x * 14).toFixed(2) + 'deg');
        card.style.setProperty('--rx', (st.y * -10).toFixed(2) + 'deg');
        card.style.setProperty('--gx', (50 + st.x * 40).toFixed(1) + '%');
        card.style.setProperty('--gy', (50 + st.y * 40).toFixed(1) + '%');
      }
      st.raf = requestAnimationFrame(loop);
    }
    if (!reduced) loop();

    // depth values from data-depth on layers
    $$('.hero__layers [data-depth]', hero).forEach(el => {
      const d = parseFloat(el.dataset.depth) || 0;
      el.style.setProperty('--depth-px', (d * -36) + 'px');
      el.style.setProperty('--depth-py', (d * -20) + 'px');
    });

    initRotator(hero);
    initHeroCards(hero);
    const lt = $('[data-laptimer]', hero);
    if (lt) initLapTimer(hero, lt);
    const snow = $('[data-hero-snow]', hero);
    if (snow && !reduced) initSnow(snow, hero, st);
  }

  function initRotator(hero) {
    const rot = $('[data-rotator]', hero);
    if (!rot) return;
    const words = $$('.hero__word', rot);
    if (words.length < 2 || reduced) return;
    let i = 0;
    setInterval(() => {
      const cur = words[i];
      i = (i + 1) % words.length;
      cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      setTimeout(() => cur.classList.remove('is-leaving'), 700);
      words[i].classList.add('is-active');
    }, 2800);
  }

  function initHeroCards(hero) {
    const cards = $$('[data-hcard]', hero);
    const dots = $$('[data-dot]', hero);
    const cap = $('[data-hero-caption]', hero);
    if (cards.length < 2) return;
    let i = 0, timer, paused = false;
    const go = n => {
      cards[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + cards.length) % cards.length;
      cards[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
      if (cap) cap.textContent = cards[i].dataset.title || '';
    };
    const start = () => { clearInterval(timer); if (!reduced) timer = setInterval(() => { if (!paused) go(i + 1); }, 3800); };
    dots.forEach((d, n) => d.addEventListener('click', () => { go(n); start(); }));
    const wrap = $('[data-hero-cards]', hero);
    wrap.addEventListener('mouseenter', () => paused = true);
    wrap.addEventListener('mouseleave', () => paused = false);
    // swipe on touch
    let sx = null;
    wrap.addEventListener('touchstart', e => sx = e.touches[0].clientX, { passive: true });
    wrap.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); } sx = null; });
    start();
  }

  /* =========================================================
     LAP TIMER — runs only while you move. Car follows a mini
     circuit; every full lap logs a time and keeps your best.
     ========================================================= */
  function initLapTimer(hero, el) {
    const path = $('[data-track]', el), car = $('[data-car]', el);
    const tEl = $('[data-time]', el), lapEl = $('[data-lap]', el), bestEl = $('[data-best]', el);
    const L = path.getTotalLength();
    const LAP_PX = 3600;               // pointer travel per lap
    const lapWord = (lapEl.textContent || 'Lap 1').replace(/\d+/, '').trim();
    const bestWord = (bestEl.textContent || 'Best').split(' ')[0];
    let total = 0, lapStart = 0, dist = 0, lap = 1, best = null, last = null, lastMove = 0, running = false, rafId = 0;
    try { const b = parseFloat(sessionStorage.getItem('tl_best_lap')); if (b > 0) best = b; } catch (e) {}

    const fmt = ms => {
      const m = Math.floor(ms / 60000), s = Math.floor(ms % 60000 / 1000), c = Math.floor(ms % 1000 / 10);
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0') + '<small>.' + String(c).padStart(2, '0') + '</small>';
    };
    const fmtPlain = ms => fmt(ms).replace(/<\/?small>/g, '');
    const placeCar = () => { const p = path.getPointAtLength(((dist % LAP_PX) / LAP_PX) * L); car.setAttribute('cx', p.x); car.setAttribute('cy', p.y); };
    const paint = () => { tEl.innerHTML = fmt(total); };
    if (best) bestEl.textContent = bestWord + ' ' + fmtPlain(best);
    placeCar();

    let prevT = 0;
    function tick(now) {
      const moving = now - lastMove < 140;
      if (moving) { total += Math.min(now - prevT, 50); paint(); }
      prevT = now;
      el.classList.toggle('is-running', moving);
      running = moving;
      rafId = moving || now - lastMove < 400 ? requestAnimationFrame(tick) : 0;
    }

    hero.addEventListener('hero:move', e => {
      const { cx, cy } = e.detail;
      el.classList.add('is-touched');
      if (last) {
        const d = Math.hypot(cx - last.x, cy - last.y);
        if (d < 200) {
          const before = Math.floor(dist / LAP_PX);
          dist += d;
          if (Math.floor(dist / LAP_PX) > before) {
            const lapTime = total - lapStart; lapStart = total; lap += 1;
            if (!best || lapTime < best) { best = lapTime; try { sessionStorage.setItem('tl_best_lap', String(best)); } catch (er) {} }
            lapEl.textContent = lapWord + ' ' + lap;
            bestEl.textContent = bestWord + ' ' + fmtPlain(best);
            el.classList.remove('flash'); void el.offsetWidth; el.classList.add('flash');
          }
          placeCar();
        }
      }
      last = { x: cx, y: cy };
      lastMove = performance.now();
      if (!rafId) { prevT = performance.now(); rafId = requestAnimationFrame(tick); }
    });
  }

  /* =========================================================
     SNOW — wind follows your cursor, flakes scatter around it
     ========================================================= */
  function initSnow(canvas, host, heroState) {
    const ctx = canvas.getContext('2d');
    const density = parseInt(canvas.dataset.density, 10) || 80;
    let w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), flakes = [], visible = true, wind = 0, raf;
    const pointer = { x: -999, y: -999, vx: 0 };
    const isFixed = canvas.classList.contains('snowfall');

    const resize = () => {
      const r = isFixed ? { width: innerWidth, height: innerHeight } : host.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = w * dpr; canvas.height = h * dpr;
      canvas.style.width = w + 'px'; canvas.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const count = Math.round(density * (w * h) / (1440 * 900));
      flakes = Array.from({ length: Math.max(20, count) }, () => mk(true));
    };
    const mk = (anywhere) => {
      const z = Math.random();
      return { x: Math.random() * w, y: anywhere ? Math.random() * h : -10, r: .6 + z * 2.4, z, vy: .3 + z * 1.1, sway: Math.random() * Math.PI * 2, a: .35 + z * .6 };
    };
    let lastPX = null;
    window.addEventListener('pointermove', e => {
      const r = isFixed ? { left: 0, top: 0 } : canvas.getBoundingClientRect();
      pointer.x = e.clientX - r.left; pointer.y = e.clientY - r.top;
      if (lastPX !== null) pointer.vx = e.clientX - lastPX;
      lastPX = e.clientX;
    }, { passive: true });

    function frame() {
      if (!visible || document.hidden) { raf = 0; return; }
      wind = lerp(wind, clamp(pointer.vx * .08, -3, 3), .04);
      pointer.vx *= .9;
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = '#fff';
      for (const f of flakes) {
        f.sway += .01 + f.z * .01;
        f.x += Math.sin(f.sway) * .35 + wind * (.4 + f.z);
        f.y += f.vy;
        const dx = f.x - pointer.x, dy = f.y - pointer.y, d2 = dx * dx + dy * dy;
        if (d2 < 9000) { const d = Math.sqrt(d2) || 1, push = (95 - d) / 95 * 2.2; f.x += dx / d * push; f.y += dy / d * push; }
        if (f.y > h + 6) Object.assign(f, mk(false));
        if (f.x > w + 6) f.x = -6; else if (f.x < -6) f.x = w + 6;
        ctx.globalAlpha = f.a;
        ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(frame);
    }
    const io = new IntersectionObserver(([en]) => { visible = en.isIntersecting; if (visible && !raf) raf = requestAnimationFrame(frame); });
    io.observe(isFixed ? document.body : host);
    document.addEventListener('visibilitychange', () => { if (!document.hidden && !raf) raf = requestAnimationFrame(frame); });
    let rt; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(resize, 150); });
    resize();
    raf = requestAnimationFrame(frame);
  }

  /* =========================================================
     Card tilt (product cards, lanes)
     ========================================================= */
  function initTilt() {
    if (!finePointer || reduced) return;
    document.addEventListener('pointermove', e => {
      const card = e.target.closest && e.target.closest('[data-tilt]');
      $$('[data-tilt].is-tilting').forEach(c => { if (c !== card) { c.classList.remove('is-tilting'); c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); } });
      if (!card) return;
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      card.classList.add('is-tilting');
      card.style.setProperty('--ry', ((x - .5) * 10).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((.5 - y) * 8).toFixed(2) + 'deg');
      card.style.setProperty('--gx', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
    }, { passive: true });
  }

  /* Apex band + DRÖHN hero parallax */
  function initParallaxBlocks() {
    $$('[data-apex], .dl').forEach(sec => {
      let tx = 0, ty = 0, x = 0, y = 0, on = false, raf = 0;
      const io = new IntersectionObserver(([en]) => { on = en.isIntersecting; if (on && !raf) raf = requestAnimationFrame(step); });
      io.observe(sec);
      sec.addEventListener('pointermove', e => {
        const r = sec.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width) * 2 - 1; ty = ((e.clientY - r.top) / r.height) * 2 - 1;
        sec.style.setProperty('--px', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        sec.style.setProperty('--py', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
        sec.style.setProperty('--streak-o', '1');
        clearTimeout(sec._st); sec._st = setTimeout(() => sec.style.setProperty('--streak-o', '0'), 500);
      });
      function step() {
        if (!on || reduced) { raf = 0; return; }
        x = lerp(x, tx, .06); y = lerp(y, ty, .06);
        sec.style.setProperty('--mx', x.toFixed(4)); sec.style.setProperty('--my', y.toFixed(4));
        raf = requestAnimationFrame(step);
      }
    });
  }

  /* =========================================================
     DRÖHN mode switch — red/blue wipe from where you click
     ========================================================= */
  function initModeSwitch() {
    const wipe = $('#ModeWipe');
    if (!wipe) return;
    try {
      const pending = sessionStorage.getItem('tl_wipe');
      if (pending) {
        const d = JSON.parse(pending);
        sessionStorage.removeItem('tl_wipe');
        wipe.classList.toggle('mode-wipe--tl', d.to === 'tl');
        wipe.style.setProperty('--wx', '50%'); wipe.style.setProperty('--wy', '50%');
        wipe.style.transition = 'none'; wipe.classList.add('is-on');
        requestAnimationFrame(() => requestAnimationFrame(() => { wipe.style.transition = ''; wipe.classList.remove('is-on'); }));
      }
    } catch (e) {}
    document.addEventListener('click', e => {
      const a = e.target.closest && e.target.closest('a[data-mode-switch]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || reduced) return;
      e.preventDefault();
      const to = a.dataset.modeSwitch;
      wipe.classList.toggle('mode-wipe--tl', to === 'tl');
      wipe.style.setProperty('--wx', e.clientX + 'px');
      wipe.style.setProperty('--wy', e.clientY + 'px');
      wipe.classList.add('is-on');
      try { sessionStorage.setItem('tl_wipe', JSON.stringify({ to })); } catch (er) {}
      setTimeout(() => { location.href = a.href; }, 520);
    });
  }

  /* =========================================================
     UI bits
     ========================================================= */
  function initMenu() {
    const menu = $('#MobileMenu');
    if (!menu) return;
    const open = $('[data-menu-open]');
    const set = on => { menu.classList.toggle('is-open', on); menu.setAttribute('aria-hidden', !on); open && open.setAttribute('aria-expanded', on); document.documentElement.style.overflow = on ? 'hidden' : ''; };
    open && open.addEventListener('click', () => set(true));
    $$('[data-menu-close]', menu).forEach(b => b.addEventListener('click', () => set(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') set(false); });
  }

  function initTabs() {
    $$('[data-tabs]').forEach(root => {
      const tabs = $$('[data-tab]', root), panels = $$('[data-panel]', root);
      tabs.forEach(t => t.addEventListener('click', () => {
        tabs.forEach(x => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
        panels.forEach(p => { const on = p.dataset.panel === t.dataset.tab; p.hidden = !on; p.classList.toggle('is-in', on); });
      }));
    });
  }

  function initRails() {
    $$('.drop').forEach(sec => {
      const rail = $('[data-rail]', sec);
      $$('[data-slide]', sec).forEach(b => b.addEventListener('click', () => {
        const slide = $('.drop__slide', rail);
        const w = slide ? slide.getBoundingClientRect().width + 16 : 300;
        rail.scrollBy({ left: w * parseInt(b.dataset.slide, 10), behavior: reduced ? 'auto' : 'smooth' });
      }));
    });
  }

  function initCopy() {
    $$('[data-copy]').forEach(b => b.addEventListener('click', () => {
      navigator.clipboard && navigator.clipboard.writeText(b.dataset.copy);
      b.classList.add('copied'); setTimeout(() => b.classList.remove('copied'), 1600);
    }));
  }

  function initForms() {
    $$('[data-autosubmit]').forEach(s => s.addEventListener('change', () => s.form.submit()));
    const rec = $('[data-recover]'), log = $('[data-login]');
    $$('[data-show-recover]').forEach(b => b.addEventListener('click', () => { rec.hidden = false; log.hidden = true; }));
    $$('[data-hide-recover]').forEach(b => b.addEventListener('click', () => { rec.hidden = true; log.hidden = false; }));
    if (rec && location.hash === '#recover') { rec.hidden = false; log.hidden = true; }
    $$('[data-confirm]').forEach(b => b.addEventListener('click', e => { if (!confirm(b.dataset.confirm)) e.preventDefault(); }));
  }

  /* =========================================================
     CART
     ========================================================= */
  const drawer = () => $('#CartDrawer');
  function openCart() {
    const d = drawer(); if (!d) return false;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const p = $('.drawer__panel', d); p && p.focus();
    return true;
  }
  function closeCart() {
    const d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  async function refreshCart(sections) {
    let html = sections && sections['cart-drawer'];
    if (!html) {
      const r = await fetch(`${TL.routes.root}?sections=cart-drawer`);
      html = (await r.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('#CartDrawer', doc), cur = drawer();
    if (fresh && cur) {
      $('.drawer__panel', cur).innerHTML = $('.drawer__panel', fresh).innerHTML;
      bindDrawer();
    }
    const count = fresh ? ($('[data-cart-count]', fresh) || {}).textContent : null;
    if (count !== null) $$('[data-cart-count]').forEach(el => { el.textContent = count; el.classList.toggle('is-empty', count === '0'); el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); });
  }
  function bindDrawer() {
    const d = drawer(); if (!d) return;
    $$('[data-drawer-close]', d).forEach(b => b.onclick = closeCart);
    $$('[data-line]', d).forEach(li => {
      $$('[data-qty-change]', li).forEach(btn => btn.onclick = async () => {
        const q = parseInt($('.qty__val', li).textContent, 10) + parseInt(btn.dataset.qtyChange, 10);
        li.classList.add('is-loading');
        await fetch(TL.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: parseInt(li.dataset.line, 10), quantity: Math.max(0, q), sections: ['cart-drawer'] }) })
          .then(r => r.json()).then(j => refreshCart(j.sections)).catch(() => location.reload());
      });
    });
  }
  function initCart() {
    bindDrawer();
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
    $$('[data-cart-open]').forEach(a => a.addEventListener('click', e => { if (openCart()) e.preventDefault(); }));
  }

  /* =========================================================
     PRODUCT
     ========================================================= */
  function initProduct(root) {
    const json = $('[data-product-json]', root);
    const data = json ? JSON.parse(json.textContent) : { variants: [] };
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add]', root), addLabel = $('[data-add-label]', root), err = $('[data-form-error]', root);
    const fieldsets = $$('[data-option-index]', root);

    // gallery
    const slides = $$('[data-media-id]', root), thumbs = $$('[data-thumb]', root), count = $('[data-gallery-count]', root);
    const show = id => {
      let idx = 0;
      slides.forEach((s, n) => { const on = String(s.dataset.mediaId) === String(id); s.classList.toggle('is-active', on); if (on) idx = n; });
      thumbs.forEach(t => t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)));
      if (count) count.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    };
    thumbs.forEach(t => t.addEventListener('click', () => show(t.dataset.thumb)));

    // options
    const selected = () => fieldsets.map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
    const markAvailability = () => {
      const sel = selected();
      fieldsets.forEach((fs, oi) => {
        $$('input', fs).forEach(inp => {
          const test = sel.slice(); test[oi] = inp.value;
          const ok = data.variants.some(v => v.available && v.options.every((o, k) => o === test[k]));
          inp.closest('.chip').classList.toggle('is-unavailable', !ok);
        });
      });
    };
    const update = () => {
      const sel = selected();
      const v = data.variants.find(x => x.options.every((o, k) => o === sel[k]));
      fieldsets.forEach((fs, k) => { const lbl = $('[data-option-value]', fs); if (lbl) lbl.textContent = '— ' + sel[k]; });
      markAvailability();
      if (!v) { addBtn.disabled = true; addLabel.textContent = TL.strings.soldOut; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? addBtn.dataset.label : TL.strings.soldOut;
      const pw = $('[data-price-wrap]', root);
      if (pw) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        pw.innerHTML = `<div class="price${sale ? ' price--sale' : ''}"><span class="price__now">${formatMoney(v.price)}</span>${sale ? `<s class="price__was">${formatMoney(v.compare_at_price)}</s>` : ''}</div>`;
      }
      if (v.media_id) show(v.media_id);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    fieldsets.forEach(fs => fs.addEventListener('change', update));
    if (fieldsets.length) markAvailability();

    // qty
    const qi = $('[data-qty-input]', root);
    if (qi) $$('[data-step]', qi).forEach(b => b.addEventListener('click', () => { const i = $('input', qi); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.step, 10)); }));

    // add to cart
    if (form) form.addEventListener('submit', async e => {
      if (!drawer()) return;
      e.preventDefault();
      err.textContent = '';
      addBtn.disabled = true;
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      try {
        const r = await fetch(TL.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        const j = await r.json();
        if (!r.ok || j.status) { err.textContent = j.description || j.message || 'Something went wrong.'; return; }
        await refreshCart(j.sections);
        toast(TL.strings.added);
        openCart();
      } catch (er) { form.submit(); }
      finally { addBtn.disabled = false; }
    });
  }

  function initRecs() {
    $$('[data-recs]').forEach(async sec => {
      if (sec.children.length) return;
      try {
        const r = await fetch(sec.dataset.url);
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
        const fresh = $('[data-recs]', doc);
        if (fresh && fresh.innerHTML.trim()) sec.innerHTML = fresh.innerHTML;
      } catch (e) {}
    });
  }

  /* gift card QR (optional lib) */
  function initGiftCard() {
    const el = $('[data-gc-qr]');
    if (!el) return;
    el.textContent = '';
  }

  /* sitewide snow */
  function initSitewideSnow() {
    const c = $('#Snowfall');
    if (c && !reduced) initSnow(c, document.body, null);
  }

    /* ---------- scroll reveals (homepage) ---------- */
  function initReveals() {
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const main = document.getElementById('MainContent');
    if (!main) return;
    const heads = main.querySelectorAll('.sec-head, .drop__head, .ethos__title, .ethos__body, .news__copy, .apex__cap');
    heads.forEach(el => el.classList.add('rv-up'));
    main.querySelectorAll('.sec-head .h2, .drop__head .h2').forEach(el => el.classList.add('rv-line'));
    const groups = ['.lanes__grid > *', '.promises__grid > *', '.drop__rail > *', '.garage .grid > *', '.ethos__ctas > *', '.news__box'];
    groups.forEach(sel => main.querySelectorAll(sel).forEach((el, i) => {
      el.classList.add('rv-pop');
      el.style.setProperty('--rv-d', (i % 6) * 80 + 'ms');
      el.style.setProperty('--rv-r', (i % 2 ? 1.5 : -1.5) + 'deg');
    }));
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('rv-in'); io.unobserve(e.target); }
    }), { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    main.querySelectorAll('.rv-up, .rv-pop, .rv-line').forEach(el => io.observe(el));
    // scroll-linked apex word
    const apex = main.querySelectorAll('.apex');
    if (apex.length) {
      let raf = 0;
      const tick = () => { raf = 0; const vh = innerHeight; apex.forEach(a => { const r = a.getBoundingClientRect(); a.style.setProperty('--sp', Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height))).toFixed(3)); }); };
      addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
      tick();
    }
  }

    /* ---------- jiggle physics for buttons (springs) ---------- */
  function initJiggle() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const SEL = '.btn, .tab, .icon-btn, .rbi__hoodie-btn, .lane__go, .chip span, .qty__btn, .rbi__skip, .drop__arrows button';
    const K = 560, C = 15;               // stiffness / damping → wobbly but quick
    const live = new Map();
    let raf = 0, last = 0;
    const get = el => {
      let s = live.get(el);
      if (!s) {
        s = { el, x: 0, y: 0, sx: 1, sy: 1, vx: 0, vy: 0, vsx: 0, vsy: 0, tx: 0, ty: 0, tsx: 1, tsy: 1, hover: false, down: false };
        el.setAttribute('data-jiggle', '');
        live.set(el, s);
      }
      return s;
    };
    const kick = () => { if (!raf) { last = performance.now(); raf = requestAnimationFrame(step); } };
    function step(now) {
      const dt = Math.min(0.032, (now - last) / 1000); last = now;
      live.forEach((s, el) => {
        const f = (p, v, t) => v + (-K * (p - t) - C * v) * dt;
        s.vx = f(s.x, s.vx, s.tx); s.vy = f(s.y, s.vy, s.ty);
        s.vsx = f(s.sx, s.vsx, s.tsx); s.vsy = f(s.sy, s.vsy, s.tsy);
        s.x += s.vx * dt; s.y += s.vy * dt; s.sx += s.vsx * dt; s.sy += s.vsy * dt;
        el.style.translate = s.x.toFixed(2) + 'px ' + s.y.toFixed(2) + 'px';
        el.style.scale = s.sx.toFixed(4) + ' ' + s.sy.toFixed(4);
        const still = Math.abs(s.vx) + Math.abs(s.vy) + Math.abs(s.vsx) * 40 + Math.abs(s.vsy) * 40 < 0.05 &&
          Math.abs(s.x - s.tx) + Math.abs(s.y - s.ty) < 0.05 && Math.abs(s.sx - s.tsx) + Math.abs(s.sy - s.tsy) < 0.001;
        if (still && !s.hover && !s.down) { el.style.translate = ''; el.style.scale = ''; el.removeAttribute('data-jiggle'); live.delete(el); }
      });
      raf = live.size ? requestAnimationFrame(step) : 0;
    }
    const aim = (s, e) => {
      const r = s.el.getBoundingClientRect();
      const nx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
      const ny = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
      s.el.style.setProperty('--gx', ((nx + 1) * 50).toFixed(1) + '%');
      s.el.style.setProperty('--gy', ((ny + 1) * 50).toFixed(1) + '%');
      if (s.down) return;
      s.tx = Math.max(-1, Math.min(1, nx)) * Math.min(7, r.width * 0.05);
      s.ty = Math.max(-1, Math.min(1, ny)) * 4;
      s.tsx = 1.05 + Math.abs(nx) * 0.025; s.tsy = 1.05 - Math.abs(nx) * 0.015;
    };
    document.addEventListener('pointerover', e => {
      const el = e.target.closest && e.target.closest(SEL);
      if (!el || e.pointerType === 'touch' || (e.relatedTarget && el.contains(e.relatedTarget))) return;
      const s = get(el); s.hover = true; s.vsy -= 2.2; s.vsx += 1.6; aim(s, e); kick();
    });
    document.addEventListener('pointermove', e => {
      if (e.pointerType === 'touch') return;
      const el = e.target.closest && e.target.closest(SEL);
      if (!el) return; const s = live.get(el); if (s && s.hover) { aim(s, e); kick(); }
    }, { passive: true });
    document.addEventListener('pointerout', e => {
      const el = e.target.closest && e.target.closest(SEL);
      if (!el || (e.relatedTarget && el.contains(e.relatedTarget))) return;
      const s = live.get(el); if (!s) return;
      s.hover = false; s.down = false; s.tx = 0; s.ty = 0; s.tsx = 1; s.tsy = 1;
      s.el.style.setProperty('--gy', '0%'); s.el.style.setProperty('--gx', '50%'); kick();
    });
    document.addEventListener('pointerdown', e => {
      const el = e.target.closest && e.target.closest(SEL);
      if (!el) return; const s = get(el);
      s.down = true; s.tsx = 1.12; s.tsy = 0.84; s.tx *= .4; s.ty = 1.5; kick();   // squish
    });
    const release = e => {
      live.forEach(s => {
        if (!s.down) return;
        s.down = false;
        const touch = e.pointerType === 'touch';
        if (touch) s.hover = false;
        s.tsx = s.hover ? 1.05 : 1; s.tsy = s.hover ? 1.05 : 1; s.ty = 0; if (!s.hover) s.tx = 0;
        s.vsy += 7; s.vsx -= 5;                                                        // boing
      });
      kick();
    };
    document.addEventListener('pointerup', release);
    document.addEventListener('pointercancel', release);
  }

  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-hero]').forEach(h => { if (h.classList.contains('hero')) initHero(h); });
    initParallaxBlocks();
    initTilt();
    initModeSwitch();
    initMenu();
    initTabs();
    initRails();
    initCopy();
    initForms();
    initCart();
    $$('[data-product]').forEach(initProduct);
    initRecs();
    initGiftCard();
    initSitewideSnow();
    initReveals();
    initJiggle();
  });
})();
